import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomeLayout from "../../../components/home/common/HomeLayout";
import LeaderBoardList from "../../../components/home/leaderboard/LeaderBoardList";
import {
  getCurrentWeekLeaderBoard,
  getLeaderboardData,
} from "../../../redux/slice/leaderboardSlice";

const LeaderBoard = () => {
  const dispatch = useDispatch();
  const data = useSelector(getLeaderboardData);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(getCurrentWeekLeaderBoard());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HomeLayout>
      <LeaderBoardList />
    </HomeLayout>
  );
};

export default LeaderBoard;
